import BackIcon from 'assets/images/header/white-back.svg'
import { useNavigate } from 'react-router-dom'
interface IHeaderProps {
    title: string
}
export default function Header({ title }: IHeaderProps) {
    const navigate = useNavigate()
    return (
        <div className=" bg-green-1 w-full px-4 h-14 flex items-center justify-between sticky top-0 z-20 items-center">
            <img
                src={BackIcon}
                alt="بازگشت"
                onClick={() => navigate(-1)}
                className=" w-6 h-6 cursor-pointer active:scale-90"
            />
            <p className=" text-white font-bold text-lg">{title}</p>
            <span className="w-6" />
        </div>
    )
}
